module.exports = __webpack_public_path__ + "img/terroir-redshift-1.a759a584.jpg";